var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-recom-container"},[_c('hr'),_c('div',{staticClass:"title box-wrapper"},[_vm._v("\n    RECOMMENDED\n  ")]),_c('div',{staticClass:"sub mb-4"},[_vm._v("\n    บริการที่หลากหลายสำหรับคุณ\n  ")]),_c('ServiceRecomm',{})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }